import * as React from 'react';
import type { SVGProps } from 'react';

const SvgLinkedIn = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={43} height={43} {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width={43} height={43} fill="#0074B3" rx={3} />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M27.833 12H16.167A4.167 4.167 0 0 0 12 16.167v11.666A4.167 4.167 0 0 0 16.167 32h11.666A4.167 4.167 0 0 0 32 27.833V16.167A4.167 4.167 0 0 0 27.833 12zm-9.166 15.833h-2.5v-9.166h2.5v9.166zm-1.25-10.223a1.465 1.465 0 0 1-1.459-1.47c0-.812.654-1.47 1.459-1.47s1.458.658 1.458 1.47c0 .812-.652 1.47-1.458 1.47zm11.25 10.223h-2.5v-4.67c0-2.806-3.334-2.594-3.334 0v4.67h-2.5v-9.166h2.5v1.47c1.164-2.155 5.834-2.314 5.834 2.064v5.632z"
      />
    </g>
  </svg>
);
export default SvgLinkedIn;
